import React from "react"
import Cookies from "universal-cookie"

export default class Logout extends React.Component {
  componentDidMount() {
    console.log("remove cookie")

    let cookies = new Cookies()

    console.log("cookie gg_token", cookies.get("gg_token"))
    console.log("cookie gg_user", cookies.get("gg_user"))
    console.log("cookie gg_refresh_token", cookies.get("gg_refresh_token"))

    cookies.remove("gg_user", { path: "/" })
    cookies.remove("gg_token", { path: "/" })
    cookies.remove("gg_refresh_token", { path: "/" })
    cookies.remove("gg_time_offset", { path: "/" })
    window.location = "/admin"
  }

  render() {
    return "LOGOUT PAGE"
  }
}
